import { createContext, useContext } from 'react';

/**
 * Shared query from the app sidebar menu search (AppLayout).
 * Used to filter in-page tab strips so they stay aligned with the sidebar filter.
 * `preferredTabId` — after auto-navigation, Tabs selects this tab id once then clears.
 */
const AppMenuSearchContext = createContext({
  query: '',
  setQuery: () => {},
  preferredTabId: null,
  setPreferredTabId: () => {},
});

export function AppMenuSearchProvider({ children, query, setQuery, preferredTabId, setPreferredTabId }) {
  return (
    <AppMenuSearchContext.Provider
      value={{ query, setQuery, preferredTabId, setPreferredTabId }}
    >
      {children}
    </AppMenuSearchContext.Provider>
  );
}

export function useAppMenuSearch() {
  return useContext(AppMenuSearchContext);
}
